function getUrlParam (paramName) {
    paramName = paramName.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");

    let regex = new RegExp("[\\?&]" + paramName + "=([^&#]*)");

    let results = regex.exec(window.location.search);

    return results === null
      ? null
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

function deleteUrlParams()
  {
    const url = new URL(window.location);
    window.history.pushState({}, '', url.pathname);
  }

function getShareUrl(guid, lat, lon, type) {
  const baseUrl = window.location.origin + window.location.pathname;
  const guidParam = `?${type}_guid=${guid}`;
  const latParam = `&lat=${lat}`;
  const lonParam = `&lon=${lon}`;
  return baseUrl + guidParam + latParam + lonParam;
}

export {getUrlParam, deleteUrlParams, getShareUrl}